export default (key: string): string | undefined => {
  const env = window?.process?.env || process?.env
  if (typeof(env) !== "undefined") {
    return env[key]
  } else {
    return undefined
  }
}
